import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "@/components/Reveal";

const PANELS = [
  {
    src: "https://images.pexels.com/photos/6077181/pexels-photo-6077181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "The Bar",
    note: "Representation before the courts and tribunals",
    speed: -40,
  },
  {
    src: "https://images.pexels.com/photos/6077091/pexels-photo-6077091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "The Library",
    note: "Research-backed opinions and pleadings",
    speed: 36,
  },
  {
    src: "https://images.pexels.com/photos/29069329/pexels-photo-29069329.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "The City",
    note: "Serving enterprise across Nairobi and beyond",
    speed: -28,
  },
];

export default function VisualBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  return (
    <section
      ref={ref}
      data-testid="visual-band"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {PANELS.map((p, i) => (
            <ParallaxPanel key={p.caption} panel={p} index={i} progress={scrollYProgress} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ParallaxPanel({ panel, index, progress }) {
  const y = useTransform(progress, [0, 1], [panel.speed, -panel.speed]);

  return (
    <FadeUp delay={index * 0.12}>
      <motion.div
        style={{ y }}
        className="sheen-target group relative rounded-3xl border border-gold/15 overflow-hidden h-[26rem] sm:h-[30rem]"
        data-testid={`visual-panel-${index}`}
      >
        <img
          src={panel.src}
          alt={panel.caption}
          className="w-full h-full object-cover opacity-70 scale-105 group-hover:scale-110 group-hover:opacity-90 transition-all duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/25 to-transparent" />
        <div className="absolute bottom-0 inset-x-0 p-7">
          <div className="font-display text-xl">{panel.caption}</div>
          <div className="text-sm text-ink-dim mt-1">{panel.note}</div>
        </div>
      </motion.div>
    </FadeUp>
  );
}
